import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

// Store
import {
  $rendererClassificationMethod,
  RendererClassificationMethodType,
  setRendererClassificationMethod,
} from '../../store/slices/sidebarMapFiltersSlice';

// Configs
import {
  RENDERER_CLASSIFICATION_METHODS,
  RendererClassificationMethodsType,
} from '../../configs/mapRendererClassificationMethods.configs';

const SELECT_TITLE = 'Classification Method';

function RendererClassificationMethodsDropdown() {
  const dispatch = useDispatch();
  const rendererClassificationMethod = useSelector($rendererClassificationMethod);

  function handleRendererClassificationMethods(event: any) {
    const { value } = event.target;
    dispatch(setRendererClassificationMethod(value as RendererClassificationMethodType));
  }

  return (
    <FormControl fullWidth className={'RendererClassificationMethods'}>
      <InputLabel id='demo-simple-select-label'>{SELECT_TITLE}</InputLabel>
      <Select
        id={'renderer-classification-method-dropdown'}
        label={SELECT_TITLE}
        labelId={'renderer-classification-method-label'}
        value={rendererClassificationMethod}
        onChange={handleRendererClassificationMethods}
      >
        {RENDERER_CLASSIFICATION_METHODS.map((step: RendererClassificationMethodsType) => {
          const { value, label } = step;

          return (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default RendererClassificationMethodsDropdown;
